import React, { Fragment, useContext, useEffect, useMemo, useRef, useState } from 'react';
import style from "./addOrderOnlineAdmin.module.css";
import axios from 'axios';
import { CompanyContext } from '../../../Context/CompanyContext.js';
import { toast } from 'react-toastify'



export default function AddOrderOnlineAdmin() {
   const [loading, setLoading] = useState(false);
   const [values, setValues] = useState({});
   const [users, setUsers] = useState([]);
   const [listTest, setListTest] = useState([]);
   const [listTestName, setListTestName] = useState([]);
   const [search, setSearch] = useState([]);
   const [user, setUser] = useState("");
   const [show, setShow] = useState(false);
   const [error, setError] = useState("");


   const { getAllCompanyInfo, allCompanyInfo } = useContext(CompanyContext);
   const closeBtnRef = useRef();
   const userInputRef = useRef();
   const testInputRef = useRef();
   const companyInputRef = useRef();

   const token = localStorage.getItem("token");
   const header = useMemo(() => ({
      token: `${process.env.REACT_APP_BEARER_TOKEN} ${token}`,
   }), [token]);


   //& Get All test And Search On Test By Test Name :
   async function addAllTestToCart() {
      setLoading(true);
      await axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/cart/addAllTestByAdmin`, { ...values }, { headers: header })
         .then(({ data }) => {
            if (data.message === "success") {
               setLoading(false);
               closeBtnRef.current.click();
               userInputRef.current.value = "";
               testInputRef.current.value = "";
               companyInputRef.current.value = "";
               setValues({});
               setUsers([]);
               setListTest([]);
               setListTestName([]);
               setSearch([]);
            }
         })
         .catch((error) => {
            setError(error.response.data.message)
            setLoading(false);
         })
   }




   //^=============================================
   function searchInputUser(e) {
      if (e.target.value === "") {
         setUsers([])
      }
      if (e.target.value.length >= 3) {
         getSearchUserData((e.target.value).toLowerCase())
      }
   }
   async function getSearchUserData(search) {
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/users?keyword=${search}`)
         .then(({ data }) => {
            if (data.message === "success") {
               setUsers(data.users)
            }
         })
         .catch((error) => {
            console.log(error.response.data.message);
         })
   }
   function handleAddUserId(id, name) {
      setValues({ userId: id });
      setUsers([])
      setShow(true);
      setUser(name);
   }
   //^=============================================





   //^=============================================
   function handleAddCompany(e) {
      setValues((prev) => ({ ...prev, companyId: e.target.value }));
   }
   //^=============================================






   //^=============================================
   //& Search Test By Test Name :
   function searchInput(e) {
      if (e.target.value === "") {
         setSearch([])
      }
      if (e.target.value.length >= 3) {
         getSearchData((e.target.value).toLowerCase())
      }
   }
   //& Get All test And Search On Test By Test Name :
   async function getSearchData(search) {
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/test?keyword=${search}`)
         .then(({ data }) => {
            if (data.message === "success") {
               setSearch(data.tests)
            }
         })
         .catch((error) => {
            console.log(error.response.data.message)
         })
   }
   //& Search Test By Test Name :
   function addTestToList(id, name) {
      if (listTest.find((ele) => ele === id)) {
         return;
      }
      setValues(prev => ({ ...prev, listIdTest: [...(prev.listIdTest || []), id] }));
      setListTest([...listTest, id])
      setListTestName([...listTestName, { id, name }])
      setSearch([])
   }
   const deleteTest = (test) => {
      setValues(prev => ({ ...prev, listIdTest: prev.listIdTest.filter(id => id !== test.id) }));
      setListTestName(prevTest => prevTest.filter(ele => ele.name !== test.name));
   };

   //^=============================================


   useEffect(() => {
      getAllCompanyInfo()
   }, [])
   return (
      <Fragment>
         <div className='container'>
            <div dir='rtl' className="modal fade" id="AddOrderOnlineAdmin" tabIndex="-1" aria-labelledby="AddOrderOnlineAdminLabel" aria-hidden="true">
               <div className="modal-dialog">
                  <div className="modal-content">

                     <div className="d-flex justify-content-between align-items-center p-3">
                        <h5 dir='rtl' className="modal-title" id="AddOrderOnlineAdminLabel">أضافة طلب اونلاين جديد</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={closeBtnRef}></button>
                     </div>

                     <div className="modal-body">
                        <div className="my-2">
                           <form >
                              <label htmlFor="user" className="form-label">الاسم او رقم التليفون</label>
                              <input ref={userInputRef} type="search" onChange={(e) => { searchInputUser(e) }} className='form-control' id='user' placeholder=' اسم المستخدم او رقم التليفون' />
                           </form>

                           {users.length ?
                              <div className={`${style.search_result} m-2 p-2 bg-body-tertiary rounded-2 overflow-auto `}>
                                 {users.map((ele) => <p key={ele._id} onClick={() => { handleAddUserId(ele._id, ele.name) }} className='bg-white border rounded-1 p-1 ps-2 fw-bold m-0 my-1 text-success cursor'>{ele.name}</p>)}
                              </div>
                              : ""
                           }

                           {show ?
                              <div className="container">
                                 <div className="row">
                                    <div className=''>
                                       <div className="p-1 py-2 bg-light rounded-2 my-1 row align-items-center border border-1">
                                          <div className="col-6 p-0">
                                             <div>
                                                <p className="text-center fw-bold  m-0">
                                                   {user}
                                                </p>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              :
                              ""
                           }
                        </div>


                        <div className="my-2">
                           <label htmlFor="company" className="form-label">اختار مقدم الخدمة</label>
                           <select ref={companyInputRef} name="company" id="company" className="form-control" onChange={(e) => { handleAddCompany(e) }}>
                              <option value="">اختيار مقدم الخدمة</option>
                              {allCompanyInfo.length > 0 ?
                                 allCompanyInfo.map((ele) =>
                                    <option value={ele._id}>{ele.name}</option>
                                 )
                                 :
                                 ""
                              }
                           </select>
                        </div>

                        <div className='my-2'>
                           <form >
                              <label htmlFor="test" className="form-label">اختار  الخدمات </label>
                              <input ref={testInputRef} type="search" onChange={(e) => { searchInput(e) }} className='form-control' id='test' placeholder='أضافة  خدمات ' name="search" />
                           </form>

                           {search.length ?
                              <div className={`${style.search_result} m-2 p-2 bg-body-tertiary rounded-2 overflow-auto `}>
                                 {search.map((ele) => <p key={ele._id} onClick={() => addTestToList(ele._id, ele.name)} className='bg-white border rounded-1 p-1 ps-2 fw-bold m-0 my-1 text-success cursor'>{ele.name}</p>)}
                              </div>
                              : ""
                           }


                           <div className='container'>
                              {listTestName.map((ele) =>
                                 <div key={ele.name} className='bg-body-secondary rounded-3'>
                                    <div className='d-flex justify-content-between px-2 my-1  bg-body-tertiary rounded-3'>
                                       <i onClick={() => { deleteTest(ele) }} className="fa-solid fa-trash text-danger btn"></i>
                                       <p className='text-center p-0 m-0'>{ele.name}</p>
                                    </div>
                                 </div>
                              )}
                           </div>
                        </div>

                        <div className=''>
                           {loading ?
                              <button className='btn bg-main btn-sm m-2'> <i className="fa-solid fa-spinner fa-spin fa-rotate-180 fa-xl"></i></button>
                              :
                              <>
                                 <button className='btn btn-new-color btn-sm m-2' onClick={() => { addAllTestToCart() }}>اتمام الطلب</button>
                                 {error ? <p className='text-danger d-inline-block'>{error}</p> : ""}
                              </>
                           }
                        </div>

                     </div>
                  </div>
               </div>
            </div>
         </div>
      </Fragment>
   )
}
